'use strict';
import * as $j_app$002edata$002e$002dApp$002dRegistered$002dUser from "./app.data.-App-Registered-User.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$28() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$28 as $c_Lapp_data_AppRegisteredUser$$anon$28 };
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$28;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$28() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$28 as $h_Lapp_data_AppRegisteredUser$$anon$28 };
$h_Lapp_data_AppRegisteredUser$$anon$28.prototype = $c_Lapp_data_AppRegisteredUser$$anon$28.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.apply__Lapp_data_AppRegisteredUser__Z = (function(a) {
  return ((a instanceof $j_app$002edata$002e$002dApp$002dRegistered$002dUser.$c_Lapp_data_AppRegisteredUser$PharmacyUser) && (a !== null));
});
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_data_AppRegisteredUser__Z(v1);
});
$c_Lapp_data_AppRegisteredUser$$anon$28.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_data_AppRegisteredUser__Z(v1);
});
var $d_Lapp_data_AppRegisteredUser$$anon$28 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$28, "app.data.AppRegisteredUser$$anon$28", ({
  Lapp_data_AppRegisteredUser$$anon$28: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$28 as $d_Lapp_data_AppRegisteredUser$$anon$28 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$28.js.map
